import {
  ComponentBox,
  EmptyResult,
  formattedPropertyModel,
} from '@wallaby-ui/core';
import classNames from 'classnames';
import React, {useMemo} from 'react';
import {useIntl} from 'react-intl';

import styles from './DocumentInfo.less';
import {TranslatedLabelValue} from 'src/js/common/components/TranslatedLabelValue';

export interface DocumentInfoOwnProps {
  // TODO: type with proper type when BE is implemented
  data: any;
}

export type DocumentInfoProps = DocumentInfoOwnProps;

export const DocumentInfo: React.FC<DocumentInfoProps> = (props) => {
  const {data} = props;
  const intl = useIntl();
  const propDefinition = useMemo(() => {
    return new formattedPropertyModel.FormattedProperty({
      type: formattedPropertyModel.FORMATTED_PROPERTY_TYPE_DATETIME,
    });
  }, []);

  const formattedDocumentVersionDate =
    formattedPropertyModel.FormattedProperty.formatValue(
      propDefinition,
      data?.documentVersionCreatedDate,
      intl
    );

  const formattedDocumentCreationDate =
    formattedPropertyModel.FormattedProperty.formatValue(
      propDefinition,
      data?.documentCreatedDate,
      intl
    );

  const formattedEncounterStartDate =
    formattedPropertyModel.FormattedProperty.formatValue(
      propDefinition,
      data.encounterStart,
      intl
    );

  const formattedEncounterEndDate =
    formattedPropertyModel.FormattedProperty.formatValue(
      propDefinition,
      data.encounterEnd,
      intl
    );

  return (
    <div className={classNames(styles.dlDocumentInfoWrapper)}>
      <ComponentBox hasScrollbar>
        {data ? (
          <div
            className={styles.dlDocumentInfoLabelValuesWrapper}
            key={data.srcPatientId}
          >
            <div className={styles.dlDocumentInfoAttributes}>
              <TranslatedLabelValue
                label={'document.info.sourceEncounterId'}
                value={data.encounterId}
              />
              <TranslatedLabelValue
                label={'document.info.sourceEncounterStartDate'}
                value={formattedEncounterStartDate}
              />
              <TranslatedLabelValue
                label={'document.info.sourceEncounterEndDate'}
                value={formattedEncounterEndDate}
              />
              <TranslatedLabelValue
                label={'document.info.documentOrigin'}
                value={data.documentOrigin}
              />
              <TranslatedLabelValue
                label={'document.info.documentVersionCreatedDate'}
                value={formattedDocumentVersionDate}
              />
              <TranslatedLabelValue
                label={'document.info.documentCreatedDate'}
                value={formattedDocumentCreationDate}
              />
              <TranslatedLabelValue
                label={'document.info.versionId'}
                value={data.versionId}
              />
              <TranslatedLabelValue
                label={'document.info.documentId'}
                value={data.documentId}
              />
              <TranslatedLabelValue
                label={'document.info.documentType'}
                value={data.documentType}
              />
            </div>
          </div>
        ) : (
          <EmptyResult />
        )}
      </ComponentBox>
    </div>
  );
};

DocumentInfo.displayName = 'DocumentInfo';
